/**
 * The hit target of one mark: a real <button> laid over the SVG (1 SVG unit = 1 px), bigger than the painted mark,
 * keyboard focusable, Enter/Space/click drill. A mark with no data stays focusable (its tooltip says "no data") but
 * does nothing on click. Owner: slice web-charts (#1115).
 */
import type * as React from 'react'

export function MarkButton({
  x,
  y,
  w,
  h,
  label,
  clickable,
  empty,
  dataX,
  dataSeries,
  onHover,
  onLeave,
  onActivate,
  children,
}: {
  x: number
  y: number
  w: number
  h: number
  label: string
  clickable: boolean
  empty?: boolean
  dataX?: string
  dataSeries?: string
  onHover: () => void
  onLeave: () => void
  onActivate: () => void
  children?: React.ReactNode
}) {
  return (
    <button
      type="button"
      data-mark
      data-x={dataX}
      data-series={dataSeries}
      data-empty={empty ? 'true' : undefined}
      aria-label={label}
      aria-disabled={clickable ? undefined : true}
      className="absolute block rounded-sm bg-transparent p-0 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-ring"
      style={{ left: x, top: y, width: Math.max(1, w), height: Math.max(1, h), cursor: clickable ? 'pointer' : 'default' }}
      onPointerEnter={onHover}
      onPointerLeave={onLeave}
      onFocus={onHover}
      onBlur={onLeave}
      onClick={clickable ? onActivate : undefined}
    >
      {children}
    </button>
  )
}
